import { gql } from '@apollo/client';

export const GET_TMS_REPORT_LISTING = gql`
    query ReportQuery($warehouseId: Long!,
                       $filters: ReportFileFiltersTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getReportFileListingForTms(warehouseId: $warehouseId, filters: $filters, pageRequest: $pageRequest) {
            content{
                id
                type
                name
                reportDate
                status
                operatorId
                operatorName
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface TmsReportListResponse {
    getReportFileListingForTms: TmsReportFileListingResponseType;
}

export interface TmsReportFileListingResponseType {
    content: ReportFileType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface ReportFileType {
    id: string;
    type: number;
    code: string;
    name: string;
    reportDate: string;
    status: number;
    operatorId?: string;
    operatorName?: string;
}

